import * as React from "react";
import { cn } from "@/lib/utils";
import { Select, SelectContent, SelectItem, SelectTrigger } from "./select";

interface SelectOption {
  value: string;
  label: string;
  description?: string;
}

interface LabeledSelectProps {
  value: string;
  onValueChange: (value: string) => void;
  options: SelectOption[];
  placeholder?: string;
  className?: string;
  icon?: React.ReactNode;
  renderOption?: (option: SelectOption) => React.ReactNode;
  disabled?: boolean;
}

export function LabeledSelect({
  value,
  onValueChange,
  options,
  placeholder,
  className,
  icon,
  renderOption,
  disabled,
}: LabeledSelectProps) {
  const labelMap = React.useMemo(() => {
    const map = new Map<string, string>();
    options.forEach((opt) => map.set(opt.value, opt.label));
    return map;
  }, [options]);

  const displayLabel = value ? (labelMap.get(value) ?? value) : null;

  return (
    <Select value={value} onValueChange={onValueChange}>
      <SelectTrigger className={className} disabled={disabled}>
        {icon}
        <span className={cn("truncate", !displayLabel && "text-muted-foreground")}>
          {displayLabel || placeholder}
        </span>
      </SelectTrigger>
      <SelectContent>
        {options.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {renderOption ? renderOption(option) : option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
